export interface SearchQueryRequest {
    itemsIds: string[]
    page: number
    size: number
    AggType: 'FLAT'
}

export const constructSearchByIdsQueryRequest = (ids: string[]): SearchQueryRequest => ({
    itemsIds: ids,
    page: 0,
    size: ids.length,
    AggType: 'FLAT'
})